import baseTheme from '../baseTheme';
var MuiList = {
    /* your custom class style overrides here */
    padding: {
        padding: baseTheme.spacing(1),
    },
};
export default MuiList;
//# sourceMappingURL=MuiList.js.map